import axios from "axios";
import i18n from "src/locales/i18n";
import { HOST_API } from "../config";
import { clearSession } from "./jwt";

const axiosInstance = axios.create({
  baseURL: HOST_API,
  headers: {
    "Content-Type": "multipart/form-data",
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      clearSession();
      return (window.location = "/auth/login");
    }
    return Promise.reject(
      (error.response && error.response.data) || "Something went wrong"
    );
  }
);

axiosInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem("accessToken");
  config.headers["Accept-Language"] = i18n.language;

  if (config.method === "get") {
    // Avoid non-simple headers on non-GET requests to reduce CORS preflight failures.
    config.headers["Cache-Control"] = "no-cache";
    config.headers["Pragma"] = "no-cache";
  } else {
    delete config.headers["Cache-Control"];
    delete config.headers["Pragma"];
  }
  if (token) {
    if (!config.headers["Content-Type"]) {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    }

    config.headers.Authorization = "Bearer " + token;
  }
  

  return config;
});

export default axiosInstance;
